import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import prospectBulkEnrichmentActions from '@/redux/prospectNowBulkEnrichment/actions';
import modalsActions from '@/redux/modals/actions';
import { Loader } from '@/components';
import { dateToString } from '@/utils/common';
import { BulkEnrichmentStatusChoices } from '@/constants/Proposals';

const AsyncProspectNowBulkEnrichment = Loadable({
  loader: () => import('./ProspectNow'),
  loading: Loader,
});

const mapStateToProps = ({ prospectNowBulkEnrichment, modals }) => ({
  ...prospectNowBulkEnrichment,
  isModalOpen: modals.isUploadProspectBulkEnrichmentFileModalOpen,
  tableData: prospectNowBulkEnrichment.data.map((data) => {
    return Object.assign(
      {},
      {
        key: data.id,
        id: data.id,
        name: data.name,
        file: data.file,
        status: BulkEnrichmentStatusChoices(data.status),
        requestedBy: `${data.user?.first_name} ${data.user?.last_name}`,
        uploaded: dateToString(data.submission_date),
        enrichedProjects: data.properties_count ?? 'N/A',
        prospectData: data.prospect_now_data,
      }
    );
  }),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchEnrichments: prospectBulkEnrichmentActions.fetchEnrichments,
      uploadFile: prospectBulkEnrichmentActions.uploadFile,
      deleteFile: prospectBulkEnrichmentActions.deleteFile,
      toggleModal: modalsActions.toggleUploadProspectBulkEnrichmentFileModal,
      onRemoveFile: prospectBulkEnrichmentActions.onRemoveFile,
      beforeUpload: prospectBulkEnrichmentActions.beforeUpload,
      setFileName: prospectBulkEnrichmentActions.setFileName,
      tableChange: prospectBulkEnrichmentActions.tableChange,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AsyncProspectNowBulkEnrichment);
